import React from "react";
import {
  Input,
  Select,
  Space,
  Button,
  Col,
  Row,
  message,
  Dropdown,
  Tag,
  Modal,
  Form,
  Tooltip,
  Checkbox,
  Switch,
  Upload,
  Image,
  Avatar,
  Drawer,
  Radio,
  DatePicker,
} from "antd";
import { Link } from "react-router-dom";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import { baseURL } from "../components/Utility";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import {
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  DownOutlined,
  UploadOutlined,
  DownloadOutlined,
  ShareAltOutlined,
  MailOutlined,
  WhatsAppOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import VehicleStore from "../store/VehicleStore";
import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";

import ListTable from "./ListTable";

import CompanyStore from "../store/CompanyStore";
import AssignVehicleToCompany from "./AssignVehicleToCompany";
import VehicleAdd from "./VehicleAdd";
import dayjs from "dayjs";

import VehicleListFields from "./Plugins/AddVehicle/VehicleListFields";
import VehicleActionColumnIcons from "./Plugins/AddVehicle/VehicleActionColumnIcons";
import GlobalList from "./Plugins/AddVehicle/GlobalList";

import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import assignvehicleIcon from "../assets/images/NewDesign/assign-vehicle.svg";
import columnIcon from "../assets/images/NewDesign/column.svg";
import deleteVehicleIcon from "../assets/images/NewDesign/delete-vehicle.svg";
import renewVehicleIcon from "../assets/images/NewDesign/renew-vehicle.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import VehicleAdd2 from "./VehicleAdd2";
import copyIcon from "../assets/images/NewDesign/copy.svg";
import conf from "../config";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import axios from "axios";
import universalCookies from "universal-cookie";
import { hasFeature } from "../utils/componentVisibility";

const features = {
  showPaymentMenu: hasFeature("paymentMenu"),
  renewVehicleInvoiceNo: hasFeature("renewVehicleInvoiceNo"),
  showWaslPermission: hasFeature("showWaslPermission"),
  showVehicleListFilters: hasFeature("showVehicleListFilters"),
  renewExtraOption: hasFeature("renewExtraOption")
};
const { Dragger } = Upload;
const dateFormat = "YYYY-MM-DD";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length >= 18) {
      val.width = 180;
    } else if (val.title?.length > 15) {
      val.width = 160;
    } else if (val.title?.length > 12) {
      val.width = 130;
    } else if (val.title?.length > 8) {
      val.width = 115;
    } else if (val.dataIndex === "status2") {
      val.width = 135;
    } else {
      val.width = 105;
    }
  });

  return arr;
};
class VehicleList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.user = this.props.getUserData().isadmin;
    this.universalCookies = new universalCookies();
    this.vehicleStore = new VehicleStore();
    this.companyStore = new CompanyStore(this);
    this.selectedCol = [
      {
        key: "18",
        title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
        dataIndex: "vehicleId",
        // fixed: "left",
        ellipsis: {
          showTitle: true,
        },
        width: 85,
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("vehiclelist") && this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        key: "1",
        title: context.translate("_ASSET_NAME_"),

        dataIndex: "vehicleName",

        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
      },
      {
        key: "19",

        title: context.translate("ARABIC_VEHICLE_NO_"),
        dataIndex: "vehicleNoArabic",
        ellipsis: {
          showTitle: true,
        },
      },

      {
        key: "2",

        title: context.translate("_ASSET_NUMBER_"),
        dataIndex: "vehicleNo",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
      },

      {
        key: "5",

        title: context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
        dataIndex: "companyName",
        ellipsis: {
          showTitle: true,
        },
        render: (companyName) => (
          <Tooltip placement="topLeft" title={companyName}>
            {companyName}
          </Tooltip>
        ),
      },
      {
        key: "6",
        // title: "Driver",
        title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
        dataIndex: "dname",
        finalWidth: 70,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        key: "7",
        // title: "Device",
        title: context.translate("_FLEET_GROUP_GROUPLIST_DEVICENAME_"),
        dataIndex: "deviceName",
        finalWidth: 70,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        key: "8",
        // title: "IMEI",
        title: context.translate("_FLEET_DASHBORD_SETTING_IMEI_"),
        dataIndex: "full_imei",
        style: { fontSize: "12px" },
        finalWidth: 100,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        key: "9",

        title: context.translate("_SIM_NUMBER_"),
        dataIndex: "simNo",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
      },
      {
        key: "trackerId",
        title: context.translate("_TRACKER_ID_"),
        dataIndex: "trackerId",

        ellipsis: {
          showTitle: true,
        },
      },
      {
        key: "10",

        title: context.translate("_INSTALLATION_DATE_"),
        dataIndex: "installDate",
        ellipsis: {
          showTitle: true,
        },
        style: { fontSize: "12px" },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "11",

        title: context.translate("_EXPIRY_DATE_"),
        dataIndex: "expiryDate",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "20",

        title: context.translate("_INSURANCE_TYPE_"),
        dataIndex: "insuranceRenewal",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "21",

        title: context.translate("_MULKIYA_TYPE_"),
        dataIndex: "mulkiyaRenewal",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "18",
        title: context.translate("ICCID"),
        dataIndex: "iccid",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
      },

      {
        key: "16",
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status2",
        style: { fontSize: "12px" },
        ellipsis: {
          showTitle: true,
        },
        render: (mainValue) => {
          let value = Number(mainValue);
          if (value === 3) {
            return (
              <div className="list-status-expired">
                {context.translate("_EXPIRED_")}
              </div>
              // <Tag
              //   style={{ width: "60px", textAlign: "center" }}
              //   color={config.deleteColor}
              // >

              //   {context.translate("_EXPIRED_")}
              // </Tag>
            );
          } else if (value === 4) {
            return (
              <div className="list-status-expiringSoon">
                {context.translate("_EXPIRINGSOON_")}
              </div>
              // <Tag
              //   style={{
              //     width: "75px",
              //     textAlign: "center",
              //     fontSize: "10px",
              //   }}
              //   color={config.ExpirySoonColor}
              // >

              //
              // </Tag>
            );
          } else if (value == 1) {
            return (
              <div className="list-status-active">
                {context.translate("_FLEET_USER_USERLIST_STATUS_ACTIVE_")}
              </div>
              // <Tag
              //   style={{ width: "60px", textAlign: "center" }}
              //   color={config.activeColor}
              // >

              //   {context.translate("_FLEET_USER_USERLIST_STATUS_ACTIVE_")}
              // </Tag>
            );
          } else if (value == 2) {
            return (
              <div className="list-status-inactive">
                {" "}
                {context.translate("_UNINSTALLED_")}
              </div>
              // <Tag
              //   style={{ width: "74px", textAlign: "center" }}
              //   color={config.inActiveColor}
              // >

              //   {context.translate("_UNINSTALLED_")}
              // </Tag>
            );
          } else if (value == 5) {
            return (
              <div className="list-status-inactive">
                {" "}
                {context.translate("_DELETED_")}
              </div>
              // <Tag
              //   style={{ width: "60px", textAlign: "center" }}
              //   color={config.inActiveColor}
              // >

              //   {context.translate("_DELETED_")}
              // </Tag>
            );
          } else if (value == 0) {
            return (
              // <Tag
              //   style={{ width: "60px", textAlign: "center" }}
              //   color={config.inActiveColor}
              // >
              //   Inactive
              // </Tag>
              <div className="list-status-inactive">Inactive</div>
            );
          }
          // else if (value == 2) {
          //   return <Tag color="red">Inactive</Tag>;
          // }
        },
      },
      {
        key: "17",

        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        ellipsis: {
          showTitle: true,
        },
        align: "center",

        render: (_, record) => {
          // console.log(_, record);
          if (
            Number(record.status2) === 3 ||
            Number(record.status2) === 1 ||
            Number(record.status2) === 2 ||
            Number(record.status2) === 4 ||
            Number(record.status) === 0
          ) {
            return (
              <>
                {(Number(this.props.getUserData().isadmin) === -1 ||
                  Number(this.props.getUserData().isadmin) === 3) && (
                    <Space>
                      {config.project === "drive7" && (
                        <>
                          <Tooltip
                            title="Download Certificate"
                            color={config.activeColor}
                          >
                            <DownloadOutlined
                              onClick={() => {
                                this.vehicleStore.downloadCertificate(
                                  record.vehicleId
                                );
                              }}
                            />
                          </Tooltip>

                          <Tooltip
                            title="Share Certificate"
                            color={config.activeColor}
                          >
                            <ShareAltOutlined
                              onClick={() => {
                                this.handleSharemodal(record.vehicleId);
                              }}
                            />
                          </Tooltip>
                        </>
                      )}

                      {/* <DeleteConfirm
                      onConfirm={(e) => {
                        e.preventDefault();
                        this.onDelete(record);
                      }}
                    >
                      <Link>
                        <Tooltip
                          // title="Delete Asset"
                          title={this.context.translate(
                            "_FLEET_VEHICLE_VEHICLELIST_DELETE_"
                          )}
                          placement="bottom"
                          color={config.tooltipColorDelete}
                        >
                          <DeleteFilled style={{ color: config.deleteColor }} />
                        </Tooltip>
                      </Link>
                    </DeleteConfirm> */}

                      <Tooltip
                        // title="Delete Asset"
                        title={this.context.translate("_COPY_VEHICLE_")}
                        placement="bottom"
                      >
                        <Image
                          src={copyIcon}
                          style={{ cursor: "pointer", width: "15px" }}
                          onClick={(e) => {
                            e.preventDefault();
                            record.forCopy = 1;
                            this.props.canUpdate("vehiclelist") &&
                              this.onEdit(record);
                          }}
                        ></Image>
                      </Tooltip>

                      <Tooltip
                        title={
                          record.status == "1"
                            ? context.translate("_ACTIVE_")
                            : context.translate(
                              "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                            )
                        }
                        placement="top"
                      >
                        {this.props.canUpdate("vehiclelist") && (
                          <Switch
                            className="switch-btn"
                            size="small"
                            checked={Number(record.status)}
                            onChange={async (val) => {
                              this.setState({ vehicleId: record.vehicleId });
                              this.setState({ isActive: val });
                              this.setState({ showStatusConfirm: true }); // open modal
                            }}
                          // defaultChecked
                          />
                        )}
                      </Tooltip>
                      <Tooltip
                        // title="Delete Asset"
                        title={this.context.translate(
                          "_FLEET_VEHICLE_VEHICLELIST_DELETE_"
                        )}
                        placement="bottom"
                      >
                        {this.props.canDelete("vehiclelist") && (
                          <Image
                            src={require("../assets/images/NewDesign/Delete.png")}
                            style={{ cursor: "pointer", width: "15px" }}
                            onClick={() =>
                              this.setState({
                                openDeleteModal: true,
                                deleteData: record,
                              })
                            }
                          ></Image>
                        )}
                      </Tooltip>
                      <Tooltip
                        title={this.context.translate(
                          "_FLEET_LOGOUT_"
                        )}
                        placement="bottom"
                      >
                        {(Number(this.props.getUserData().isadmin) == -1 || Number(this.props.getUserData().isadmin) == 3) &&
                          <Image
                            src={require("../assets/images/NewDesign/logout.png")}
                            style={{ cursor: "pointer", width: "15px" }}
                            onClick={() => {
                              // debugger
                              this.setState({
                                showStatusLogout: true,
                                logOutVehicleId: record.vehicleId,
                                vehicleNo: record.vehicleNo,
                              })
                            }
                            }
                          ></Image>
                        }

                      </Tooltip>

                      <Dropdown
                        // overlayClassName="export-dropdown"
                        menu={this.actionColumn}
                        trigger={["click"]}
                      >
                        <Image
                          style={{ cursor: "pointer", width: "6px" }}
                          src={kebabIcon}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({ editData: record });
                          }}
                        ></Image>
                      </Dropdown>

                      {/* <Tooltip
                      title={
                        record.status == "1"
                          ? this.context.translate("_ACTIVE_")
                          : this.context.translate(
                              "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                            )
                      }
                      placement="top"
                      color={
                        record.status == "1"
                          ? config.activeColor
                          : config.inActiveColor
                      }
                    >
                      <Switch
                        size="small"
                        checked={Number(record.status)}
                        onChange={async (val) => {
                          this.setState({ vehicleId: record.vehicleId });
                          this.setState({ isActive: val });
                          this.setState({ showStatusConfirm: true }); // open modal
                        }}
                        // defaultChecked
                      />
                    </Tooltip> */}
                    </Space>
                  )}
              </>
            );
          }
        },
      },
    ];

    //check which user-------
    let column = this.selectedCol;
    if (this.user === -1 || this.user === 3) {
      column = this.selectedCol;
    } else if (this.user === 1 || this.user === 0) {
      column = this.selectedCol?.filter(
        (val) =>
          val.dataIndex !== "full_imei" &&
          val.dataIndex !== "simNo" &&
          val.dataIndex !== "iccid" &&
          val.dataIndex !== "Action"
      );
    } else {
      column = this.selectedCol?.filter((val) => val.dataIndex !== "Action");
    }
    this.selectedCol = column;
    // ------------------------------

    let hideColumns = this.selectedCol;
    if (
      config.project === "awtltrack" ||
      config.project === "starlingeye" ||
      config.project === "trackeazy"
    ) {
      hideColumns = this.selectedCol?.filter(
        (val) => val.dataIndex !== "trackerId"
      );
    }
    this.selectedCol = hideColumns;

    this.state = {
      status: 0,
      loading: false,
      exportLoading: false,
      pageSize: 50,
      currentPage: 1,
      companyLoading: false,
      renewVehicle: false,
      selectedVehicle: [],
      loadData: 0,
      showDeleteModal: false,
      companyVal_Lab: "",
      full_imei: "",
      // selectedVehicle1:false
      selectedRowKeys: [],
      openAssignForm: false,
      openVehicleAddForm: false,
      vehicleIdForEdit: "",
      showAlertModal: false,
      modalVisible: false,
      companyId: "",
      searchField: "",
      showStatusConfirm: false,
      selectedColumns: widthAdderFunc(this.selectedCol),
      isAllVehicle: false,
      showUpload: false,
      excelFile: "",
      excelCompanyId: "",
      openShareModal: false,
      vehicleId: "",
      column: this.selectedCol,

      openDeleteModal: false,
      deleteData: {},
      editData: {},
      forCopy: 0,
      deviceFilter: "",
      vehiclesNotExist: [],
      deletedVehicles: [],
      showUploadInfo: false,
      duplicateVehicles: [],
      duplicateImei: [],
      importedVehicles: [],
      showBulkDelete: false,
      apiRegistrationPopup: false,
      forceUpdateWASLPopup: false,
      radioBtnValue: null,
      chekboxRowData: [],
      showStatusLogout: false,
      logOutVehicleId: "",
      vehicleNoSearch: null,
      installFrom: null,
      installTo: null,
      clearCache: false,
      showRenewDate: false
    };

    // this.formRef = React.createRef();

    this.waslMenuProps = {
      items: [
        {
          label: (
            <Link to={"/waslvehiclelist"}>
              {" "}
              <PlusOutlined style={{ marginRight: "5px" }} />
              {/* WASL */}
              {context.translate("_WASL_")}
            </Link>
          ),
          key: "1",
        },
        {
          label: (
            <Link to={"/wasltrip"}>
              {" "}c
              <PlusOutlined style={{ marginRight: "5px" }} />
              {/* WASL Trip */}
              {context.translate("_WASL_TRIP_")}
            </Link>
          ),
          key: "2",
        },
      ],
      onClick: () => { },
    };

    this.proAWTLColumns =
      [
        {
          title: context.translate("_INSTALLATION_TYPE_"),
          dataIndex: "InstallationType",
          key: "InstallationType",
        },
        {
          title: context.translate("_HOUR_METER_READING_"),
          dataIndex: "hourMeterReading",
          key: "hourMeterReading",
        },
        {
          title: context.translate("_REGULAR_RUNNING_HOUR_"),
          dataIndex: "regularRunningHours",
          key: "regularRunningHours",
        },
        {
          title: context.translate("_INSTALLER_"),
          dataIndex: "installer",
          key: "installer",
        },
        {
          title: context.translate("_MAX_HOUR_PER_DAY_"),
          dataIndex: "maxHoursPerDay",
          key: "maxHoursPerDay",
        },
        {
          title: context.translate("_MOVING_RPM_"),
          dataIndex: "movingRPM",
          key: "movingRPM",
        },
        {
          title: context.translate("_STOPPED_RPM_"),
          dataIndex: "rpm",
          key: "rpm",
        },
        {
          title: context.translate("_IDEL_RPM_"),
          dataIndex: "idelRPM",
          key: "idelRPM",
        },
        {
          title: context.translate("_MANUFACTURER_"),
          dataIndex: "manufactureYear",
          key: "manufactureYear",
        },
        {
          title: context.translate("_TYPE_OF_VEHICLE_"),
          dataIndex: "vehicleTypeNew",
          key: "vehicleTypeNew",
        },
        {
          title: context.translate("_FUEL_TYPE_"),
          dataIndex: "fuelType",
          key: "fuelType",
        },
        {
          title: context.translate("_MILEAGE_"),
          dataIndex: "fuelConsumption",
          key: "fuelConsumption",
        },
        {
          title: context.translate("_COMMENTS_"),
          dataIndex: "comment",
          key: "comment",
        },
        {
          title: context.translate("_COST_"),
          dataIndex: "totalVehicleCost",
          key: "totalVehicleCost",
        },
        {
          title: context.translate("_INSATALLED_LOCATION_"),
          dataIndex: "installedLocation",
          key: "installedLocation",
        },
        {
          title: context.translate("_REGION_"),
          dataIndex: "region",
          key: "region",
        },
        {
          title: context.translate("_BRANCH_"),
          dataIndex: "branch",
          key: "branch",
        },
        {
          title: context.translate("_OWNERSHIP_"),
          dataIndex: "ownership",
          key: "ownership",
        },
        {
          title: context.translate("_MAKE_"),
          dataIndex: "vehicleBrand",
          key: "vehicleBrand",
        },
        {
          title: context.translate("_DEVICE_BRAND_"),
          dataIndex: "deviceBrandName",
          key: "deviceBrandName",
        },
        {
          title: context.translate("_ASSET_TYPE_"),
          dataIndex: "assetTypeCustomName",
          key: "assetTypeCustomName",
        },
        {
          title: context.translate("_LAST_CONNECTION_"),
          dataIndex: "lastUpdate",
          key: "lastUpdate",
        },
        {
          title: context.translate("_LOCATION_"),
          dataIndex: "location",
          key: "location",
        },
        {
          title: context.translate("_IGNITION_"),
          dataIndex: "acc",
          key: "acc",
        },
        {
          title: context.translate("_SPEED_"),
          dataIndex: "speed",
          key: "speed",
        },
        {
          title: context.translate("_FLEET_DASHBORD_SETTING_ODOMETER_"),
          dataIndex: "distance",
          key: "distance",
        },
        {
          title: context.translate("_CHASSIS_"),//chassis
          dataIndex: "vin",
          key: "vin",
        },
        {
          title: context.translate("_SIM_VENDOR_"),
          dataIndex: "simType",
          key: "simType",
        },
        {
          title: context.translate("_SEQUENCE_NUMBER_"),
          dataIndex: "sequenceNo",
          key: "sequenceNo",
        },
        {
          title: context.translate("_BASE_LOCATION_"),
          dataIndex: "baseLocation",
          key: "baseLocation",
        },
        {
          title: context.translate("_RENEWED_AT_"),
          dataIndex: "renewedAt",
          key: "renewedAt",
          render: (renewedAt) => {
            return <>{dayjs(renewedAt).format("YYYY-MM-DD")}</>
          }
        },
        {
          title: context.translate("_INVOICE_NO_"),
          dataIndex: "invoiceNo",
          key: "invoiceNo",
        },
        {
          title: context.translate("_SEND_TO_API_"),
          dataIndex: "sendToApi",
          key: "sendToApi",
          render: (text, record) => {
            const value = Number(record.sendToApi || 0);

            return (
              <>
                <Checkbox
                  checked={value === 1 || value === 2 || value === -1}
                  onChange={(e) =>
                    this.handleCheckboxChangeForColumns(e, record, "sendToApi")
                  }
                />

                <span style={{ marginLeft: 8 }}>
                  {value === 1
                    ? "Jeddah"
                    : value === 2
                      ? "Riyadh"
                      : null}
                </span>
              </>
            );
          },
        },
        {
          title: context.translate("_FORCE_POST_TO_WASL_"),
          dataIndex: "forcePostToWasl",
          key: "forcePostToWasl",
          render: (text, record) => (
            <Checkbox
              // checked={record.forcePostToWasl === 1}
              onChange={(e) =>
                this.handleCheckboxChangeForColumns(e, record, "forcePostToWasl")
              }
            />
          ),
        },
      ]


    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      ...(conf.pythonReport === 1 ? this.proAWTLColumns : []),
      {
        title: context.translate("_CREATE_DATE"),
        dataIndex: "createdate",
        key: "createdate",
      },
      {
        title: context.translate("_FLEET_VEHICLE_VEHICLEDETAIL_SERVICEEXPIRE_"),
        dataIndex: "serviceexpire",
        key: "serviceexpire",
      },
      {
        title: context.translate("_DEPARTMENT_"),
        dataIndex: "department",
        key: "department",
      },
      {
        title: context.translate("_AREA_"),
        dataIndex: "area",
        key: "area",
      },
      {
        // title: "Installation Type",
        title: context.translate("_RESPONSIBLE_MANAGER"),
        dataIndex: "responsibleManager",
        key: "responsibleManager",
      },
      {
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_MODEL_"),
        dataIndex: "model",
        key: "model",
      },
      {
        title: context.translate("_CONTACT_NO_"),
        dataIndex: "contactNo",
        key: "contactNo",
      },
      {
        title: context.translate("_EMAIL_"),
        dataIndex: "email",
        key: "email",
      },
    ]);

    this.actionColumn = {
      items: [
        this.props.canDelete("vehiclelist") && {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },
      ],
    };

    const isadmin = this.props.getUserData().isadmin;

    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async (e) => {
                this.state.selectedVehicle.length > 0
                  ? await this.setState({ renewVehicle: true })
                  : await this.setState({ showAlertModal: true });
              }}

            >
              {" "}
              <Avatar
                style={{ height: "22px", width: "22px", borderRadius: "0px" }}
                src={renewVehicleIcon}
              ></Avatar>
              {context.translate("_RENEW_VEHICLE_")}
            </div>
          ),
          key: "renew",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.setState({ openAssignForm: true })}
            >
              {" "}
              <Avatar
                style={{ height: "22px", width: "22px", borderRadius: "0px" }}
                src={assignvehicleIcon}
              ></Avatar>
              {context.translate("_ASSIGN_VEHICLE_")}
            </div>
          ),
          key: "assign",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async () => {
                this.state.selectedVehicle.length > 0
                  ? await this.setState({ showDeleteModal: true })
                  : await this.setState({ showAlertModal: true });
              }}
            >
              {" "}
              <Avatar
                style={{ height: "20px", width: "20px", borderRadius: "0px" }}
                src={deleteVehicleIcon}
              ></Avatar>
              {context.translate("_DELETE_VEHICLE_")}
            </div>
          ),
          key: "delete",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.setState({ modalVisible: true })}
            >
              {" "}
              <Avatar
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={columnIcon}
              ></Avatar>
              {context.translate("_COLUMNS_")}
            </div>
          ),
          key: "columns",
        },
        // ...(isadmin === -1 || isadmin === 3
        //   ? [
        //     {
        //       label: (
        //         <Link
        //           style={{
        //             display: "flex",
        //             alignItems: "center",
        //             gap: "5px",
        //             textDecoration: "none",
        //           }}
        //           to={"/waslvehiclelist"}
        //         >
        //           <PlusOutlined
        //             style={{
        //               height: "14px",
        //               width: "14px",
        //               borderRadius: "0px",
        //             }}
        //           />
        //           {context.translate("_WASL_")}
        //         </Link>
        //       ),
        //       key: "wasl",
        //     },
        //     {
        //       label: (
        //         <Link
        //           style={{
        //             display: "flex",
        //             alignItems: "center",
        //             gap: "5px",
        //             textDecoration: "none",
        //           }}
        //           to={"/wasltrip"}
        //         >
        //           <PlusOutlined
        //             style={{
        //               height: "14px",
        //               width: "14px",
        //               borderRadius: "0px",
        //             }}
        //           />
        //           {context.translate("_WASL_TRIP_")}
        //         </Link>
        //       ),
        //       key: "waslTrip",
        //     },
        //   ]
        //   : []),
        ...(
          // (isadmin === -1 || isadmin === 3) && ( this.props.canView("waslvehicle"))
          (
            (isadmin === -1 || isadmin === 3) &&
            (
              !features.showWaslPermission ||
              this.props.canView("waslvehicle")
            )
          )
            ? [
              {
                label: (
                  <Link
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      textDecoration: "none",
                    }}
                    to={"/waslvehiclelist"}
                  >
                    <PlusOutlined
                      style={{
                        height: "14px",
                        width: "14px",
                        borderRadius: "0px",
                      }}
                    />
                    {context.translate("_WASL_")}
                  </Link>
                ),
                key: "wasl",
              },
              {
                label: (
                  <Link
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      textDecoration: "none",
                    }}
                    to={"/wasltrip"}
                  >
                    <PlusOutlined
                      style={{
                        height: "14px",
                        width: "14px",
                        borderRadius: "0px",
                      }}
                    />
                    {context.translate("_WASL_TRIP_")}
                  </Link>
                ),
                key: "waslTrip",
              },
            ]
            : [])

        // [...(isadmin !== -1 && isadmin !== 3
        // ?  {
        //     label: (
        //       <Link
        //         style={{
        //           display: "flex",
        //           alignItems: "center",
        //           gap: "5px",
        //           textDecoration: "none",
        //         }}
        //         to={"/waslvehiclelist"}
        //       >
        //         {" "}
        //         <PlusOutlined
        //           style={{ height: "14px", width: "14px", borderRadius: "0px" }}
        //         />
        //         {context.translate("_WASL_")}
        //       </Link>
        //     ),
        //     key: "wasl",
        //   },
        //   {
        //     label: (
        //       <Link
        //         style={{
        //           display: "flex",
        //           alignItems: "center",
        //           gap: "5px",
        //           textDecoration: "none",
        //         }}
        //         to={"/wasltrip"}
        //       >
        //         {" "}
        //         <PlusOutlined
        //           style={{ height: "14px", width: "14px", borderRadius: "0px" }}
        //         />
        //         {context.translate("_WASL_TRIP_")}
        //       </Link>
        //     ),
        //     key: "waslTrip",
        //   }, :[])]
      ],
    };

    this.ExportPaymentMenu = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async (e) => {

                const postData = {
                  cid: this.state.companyId,
                  vehicleId: this.state.selectedVehicle,
                  token: this.state.token,
                  userId: this.props.getUserData().userId,
                }

                this.vehicleStore.getPaymentUrl(postData)

              }

              }

            >
              {" "}
              <Avatar
                style={{ height: "22px", width: "22px", borderRadius: "0px" }}
                src={renewVehicleIcon}
              ></Avatar>
              {context.translate("_RENEW_VEHICLE_")}
            </div>
          ),
          key: "renew",
        }


      ]

    }
  }

  handleCheckboxChangeForColumns = (e, record, field) => {
    // console.log(e.target.checked, "e.target.checked")
    const checked = e.target.checked ? 1 : 0;

    // console.log(checked, "wertyuiuytreswawedrfgth", field)

    this.vehicleStore.vehicles = this.vehicleStore.vehicles.map((item) => {
      if (item.vehicleId === record.vehicleId) {
        return {
          ...item,
          [field]: checked === 1 ? -1 : null, // or 0 if you prefer
        };
      }
      return item;
    });


    if (checked === 1 && field === "sendToApi") {
      this.setState({
        apiRegistrationPopup: true,
        chekboxRowData: record,
      });
    }

    if (checked === 1 && field === "forcePostToWasl") {
      this.setState({
        forceUpdateWASLPopup: true,
        chekboxRowData: record,
      });
    }

  };

  handleCheckboxChange = async (column) => {
    // console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      // console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      // console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleSharemodal = (vehicleId) => {
    this.setState({
      openShareModal: true,
      vehicleId: vehicleId,
    });
  };
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setVehicleStates = this.context.viewStateStore.vehicleDetailsObject;
      // console.log(setVehicleStates);
      if (setVehicleStates.companyId !== "") {
        await this.vehicleStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          // searchField: setVehicleStates.searchText,
          companyId: setVehicleStates.companyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,

          usercompanyId: this.props.getUserData().userCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setVehicleStates.companyId
        );

        await this.setState({ loadList: 1 });
        await this.setState({ companyVal_Lab: singleData });
      }
      this.setState({ listDataUpdate: false });
    }
  }

  loadSessionState = (sessionKey, stateKey) => {
    const data = sessionStorage?.getItem(sessionKey);

    if (data) {
      const parsed = JSON.parse(data);
      this.setState({
        [stateKey]: parsed[stateKey],
      });

      return parsed[stateKey];
    }

    return null;
  };

  async componentDidMount() {

    this.loadSessionState('status_vehiclelist_session', 'status');
    // this.loadSessionState('deviceFilter_vehiclelist_session', 'deviceFilter');
    this.loadSessionState('searchField_vehiclelist_session', 'searchField');

    const companyVal_Lab = this.loadSessionState(
      'companyVal_Lab_vehiclelist_session',
      'companyVal_Lab'
    );

    if (companyVal_Lab) {
      this.setState(
        {
          companyId: companyVal_Lab.value,
        },
        () => {
          this.handleSearch();
        }
      );
    }

    let tokendata = this.universalCookies.get("data")
      ? JSON.parse(base64_decode(this.universalCookies.get("data")))
      : "";
    const userToken = tokendata.userToken;

    this.setState({ token: userToken });
    if (this.props.params.status === "4") {
      await this.setState({ status: 4 });
    }
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        excelCompanyId: this.props.getUserData().userCompanyId,
      });

      //  console.log(this.state.companyId)
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    if (Number(this.props.getUserData().isadmin) === 3) {
      await this.setState({ companyId: -1 });

      this.setState({ companyId: -1 }, () => {
        this.handleSearch();
      });

      await this.setState({ loadData: 1 });
    }

    await this.setState({ column: this.state.selectedColumns });

    this.setState({ pageSize: 50 });
  }

  onSelectRenew = (value) => {
    if (value == "14") {
      this.setState({ showRenewDate : true });
    } else {
      this.setState({ showRenewDate : false });
    }
  };


  async handleChange(comp) {
    if (comp) {
      await this.setState({
        companyId: comp.value,
        currentPage: 1,
        pageSize: 50,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        comp.value,
        1
      );
      // console.log(singleData, comp.value);
      await this.setState({
        companyVal_Lab: singleData,
        companyId: comp.value,
      });
      await this.handleSearch();
    } else {
      // console.log("innn");
      await this.setState({
        companyId: null,
        companyVal_Lab: null,
      });
      this.vehicleStore.vehicles = [];
      this.vehicleStore.total = 0;
      this.setState({ loadData: 1 });
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      status: this.state.status,
      searchField: this.state.searchField,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      usercompanyId: this.props.getUserData().userCompanyId,
      vehicleNoSearch: this.state.vehicleNoSearch,
      installFrom: this.state.installFrom,
      installTo: this.state.installTo,
      clearCache: this.state.clearCache
      // usercompanyId: this.props.getUserData().userCompanyId,
    });

    await this.setState({ loading: false, loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    // console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  onEdit = async (record) => {
    const vehicleId = record.vehicleId;
    if (vehicleId) {
      this.context.viewStateStore.setVehicleStates({
        companyId: record.companyId,
      });
      // this.props.navigate("/vehicleadd/" + vehicleId);
      await this.setState({
        vehicleIdForEdit: vehicleId,
        forCopy: record.forCopy,
      });
      await this.setState({ openVehicleAddForm: true });
    }
  };

  async onDelete(record) {
    // console.log(record);
    // console.log(record.vehicleId, "record");
    const response = await this.vehicleStore.deleteRecord({
      vehicleId: record.vehicleId,
      full_imei: record.full_imei,
    });
    // console.log(response);
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  searchInput = async (value) => {
    sessionStorage.setItem(
      "searchField_vehiclelist_session",
      JSON.stringify({
        searchField: value,
      })
    );

    if (value.length >= 3 || value.length === 0) {
      this.setState({ loading: true })
      await this.vehicleStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
        status: this.state.status,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });

      this.setState({
        loadList: 1,
        currentPage: 1,
        loading: false
      });
    }
  };

  // searchInput = async (e) => {
  //   const value = e.target.value;
  //   sessionStorage.setItem('searchField_vehiclelist_session', JSON.stringify({
  //     searchField: e.target.value
  //   }));
  //   // await this.setState({searchField:value})
  //   if (value.length >= 3) {
  //     await this.vehicleStore.loadData({
  //       offset: 0,
  //       limit: this.state.pageSize,
  //       searchField: value,
  //       companyId: this.state.companyId,
  //       status: this.state.status,
  //       isadmin: this.props.getUserData().isadmin,
  //       userId: this.props.getUserData().userId,
  //       usercompanyId: this.props.getUserData().userCompanyId,
  //     });
  //     await this.setState({ loadList: 1 });
  //   } else if (value.length === 0) {
  //     await this.vehicleStore.loadData({
  //       offset: 0,
  //       limit: this.state.pageSize,
  //       searchField: value,
  //       companyId: this.state.companyId,
  //       status: this.state.status,
  //       isadmin: this.props.getUserData().isadmin,
  //       userId: this.props.getUserData().userId,
  //       usercompanyId: this.props.getUserData().userCompanyId,
  //     });
  //     await this.setState({ currentPage: 1 });
  //   }
  // };

  async searchInputButton() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.vehicleStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
        status: this.state.status,
        deviceFilter: this.state.deviceFilter,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ loadData: 1, currentPage: 1 });
    }
  }

  warningRenewVehicle = async () => {
    Modal.warning({
      title: this.context.translate("_FLEET_ALERT_"),
      content: this.context.translate("_SELECT_VEHICLES_"),
      style: {
        padding: "20px !important",
        borderRadius: "10px",
      },
    });
  };

  onRenewVehicleSubmit = async (value) => {

    let renewDate = value ?.renewDate ? value?.renewDate?.format(dateFormat) : null;
    value.renewDate = renewDate;   
    const data = { ...value, vehicleId: this.state.selectedVehicle };
   
    const resp = await this.vehicleStore.renewVehicle(data);

    if (resp.data.success === "S") {

      message.success(resp.data.message);

      this.setState({
        selectedVehicle: [],
        renewVehicle: false,
        showRenewDate: false,
      });

    } else if (resp.data?.errors?.[0]?.invoiceNo) {
      message.error(resp.data.errors[0].invoiceNo);
    } else {
      message.error(resp.data.message);
    }

    if (resp.data.message) {
      this.setState({ renewVehicle: false, showRenewDate: false });
      this.formRef.current?.resetFields();
    }

    await this.handleSearch();
    await this.setState({ loadData: 1 });

  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.excelCompanyId,
      excelFile: this.state.excelFile,
    };
    const resp = await this.vehicleStore.addVehicleByExcel(data);

    if (resp?.success === "S") {
      this.setState({
        showUploadInfo: true,
        duplicateVehicles: resp.data.existingVehicleNos || [],
        duplicateImei: resp.data.existingImeis || [],
        importedVehicles: resp.data.importedVehicles || [],
      });
      // this.formRef.current?.resetFields();
    }
    this.setState({ showUpload: false });
    this.setState({ excelFile: "" });
    this.handleSearch();
    if (resp.message) {
      this.setState({ showUpload: false });
      this.formRef.current?.resetFields();
    }
  };
  validateFile = (file) => {
    this.setState({ fileList: file });
    // console.log(file);

    const maxSize = conf.UploadExcelSize;
    if (file.size > maxSize) {
      message.error("File size must be less than or equal to 1MB");
      return false;
    }
    return true;
  };

  getUploadData = async (fileUp) => {
    // console.log(fileUp.file.name)
    let fileinfo = fileUp.file.response;

    // console.log(fileinfo);

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  deleteMultipleVehicles = async (value) => {
    // console.log(value);
    let flag = 0;
    const deleteVehicle = this.state.full_imei.forEach(async (val) => {
      // console.log(val);

      const response = await this.vehicleStore.deleteRecord({
        vehicleId: val.vehicleId,
        full_imei: val.full_imei,
      });
      // console.log(response);
      if (response?.data?.success === "S") {
        if (flag === 0) {
          message.success(response.data.message);
        }

        this.handleSearch();
        flag++;
      } else {
        message.error(response.data.message);
      }
    });
  };

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // console.log(resp.data.message);
      // this.props.navigate("/vehiclelist");
      this.setState({ openVehicleAddForm: false });
      await this.setState({ listDataUpdate: true });
    } else if (resp.data.success == "F0") {
      if (resp.data.errors[0]?.full_imei) {
        message.error(this.context.translate(resp.data.errors[0]?.full_imei));
      }
    } else {
      message.error(this.context.translate(resp.data.message));
    }
  };

  confirmStatus = async (status) => {
    const data = {};

    data.vehicleId = this.state.vehicleId;
    data.activeStatus = this.state.isActive === true ? 1 : 0;

    await this.vehicleStore.updateStatus(data);

    // console.log(data);

    this.setState({ showStatusConfirm: false });
    await this.handleSearch();
    //  await this.setState({ loading: true });
    //   await this.driversStore.loadData({ offset: 0, limit: 50 });
    // await this.setState({ loading: false });
  };

  closeModal = () => {
    this.setState({ openVehicleAddForm: false });
  };
  closeModalAssign = () => {
    this.setState({ openAssignForm: false });
  };

  shareToWhatsApp = () => {
    var url =
      config.baseURL +
      "index.php?c=vehicle&a=downloadCertificatePdf&vid=" +
      this.state.vehicleId;

    var url2 = encodeURIComponent(url);
    // console.log(url2);

    window.open("https://wa.me/?text=" + url2);
  };

  shareToEmail = () => {
    window.open("https://www.google.com/gmail/about/");
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });
    }
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };
  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    // console.log(this.state.token);
    try {
      const formData = new FormData();
      formData.append("excelFile", file);
      formData.append("fileType", "accountimport");
      formData.append("fieldName", "excelFile");

      const response = await axios.post(
        config.NodeUrl + "/vehicle/uploadExcel",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  onExcelDeleteSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.deleteCompanyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      excelFile: this.state.excelFile,
    };
    const resp = await this.vehicleStore.deleteVehicleByExcel(data);

    if (resp?.success === "S") {
      this.setState({
        showUploadInfo: true,
        vehiclesNotExist: resp.data.vehiclesNotExist || [],
        deletedVehicles: resp.data.deletedVehicles || [],
      });
      // this.formRef.current?.resetFields();
    }
    this.setState({ showUpload: false });
    this.setState({ excelFile: "" });
    this.handleSearch();
    if (resp.message) {
      this.setState({ showBulkDelete: false });
      this.formRef.current?.resetFields();
    }
  };

  handleApiRegistration = async () => {
    const vehicleId = this.state.chekboxRowData?.vehicleId

    if (this.state.radioBtnValue) {
      const data = { "sendToApi": this.state.radioBtnValue, "vehicleId": vehicleId, columnName: "sendToApi" }

      // console.log(data)


      const response = await this.vehicleStore.updateColumnsData(data)

      this.vehicleStore.vehicles = this.vehicleStore.vehicles.map((item) => {
        if (item.vehicleId === vehicleId) {
          return {
            ...item,
            sendToApi: this.state.radioBtnValue, // 🔥 update value
          };
        }
        return item;
      });
      this.setState({ apiRegistrationPopup: false })
    
      this.setState({ clearCache: true }, async () => {
        await this.handleSearch();
      });

    }

  }

  handleRadioChange = (e) => {
    const value = e.target.value;

    this.setState({ radioBtnValue: value })
  };

  handleUpdateWASLDATA = async () => {
    // { "vehicleId": 120839, "forcePostToWasl": 1 }

    const vehicleId = this.state.chekboxRowData?.vehicleId


    const data = { "forcePostToWasl": 1, "vehicleId": vehicleId, columnName: "forceUpdateWASL" }

    // console.log(data)

    await this.vehicleStore.updateColumnsData(data)


    this.setState({ forceUpdateWASLPopup: false })
    await this.handleSearch()

  }
  confirmLogoutStatus = async () => {
    const data = {
      vehicleId: this.state.logOutVehicleId,
    };

    const vehicleNo = {
      vehicleNo: this.state.vehicleNo,
    };

    const response = await this.vehicleStore.logoutVehicle(data);
    if (response?.success === "S") {
      message.success(response.message);
      this.setState({ showStatusLogout: false });
      // this.props.navigate("/companydriverslist");
    } else {
      message.error(response.message);
    }
  };
  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "130px", borderRadius: "8px" }
      : { width: "130px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={18}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  showAll={1}
                  allowClear={true}
                  onChange={(value) => {
                    this.handleChange(value)
                    this.setState({ selectedValue: value })
                    sessionStorage.setItem('companyVal_Lab_vehiclelist_session', JSON.stringify({
                      companyVal_Lab: value
                    }));
                  }}

                  //onChange={(val) => this.setState({ selectedValue: val })}
                  // disabled={this.state.companyLoading}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  // style={{ width: 200 }}
                  style={companyInputBox}
                />

                {/* {(this.props.getUserData().isadmin === 3 ||
                  this.props.getUserData().isadmin === -1) && (
                  <Checkbox
                    checked={this.state.isAllVehicle}
                    onChange={async (e) => {
                      await this.setState({ isAllVehicle: e.target.checked });

                      if (this.state.isAllVehicle) {
                        await this.setState({ companyId: -1 });
                        await this.handleSearch();
                      } else {
                        this.vehicleStore.vehicles = [];
                        this.vehicleStore.total = 0;
                      }
                      await this.setState({ loadData: 1 });
                    }}
                  >
                    All Vehicle
                  </Checkbox>
                )} */}
                <Select
                  className="searchInput"
                  style={{ width: 100, borderRadius: "25px" }}
                  onSelect={async (value) => {
                    await this.setState({ status: value });
                    // await this.searchInputButton();
                    await this.handleSearch()
                    sessionStorage.setItem('status_vehiclelist_session', JSON.stringify({
                      status: value
                    }));
                  }}
                  defaultValue={
                    this.props.params.status === "4" ? 4 : this.state.status
                  }
                  value={this.state.status}
                  // placeholder="Status"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"
                  )}
                >
                  <Select.Option value={0}>
                    {this.context.translate("_ALL_")}
                  </Select.Option>
                  <Select.Option value={1}>
                    {this.context.translate("_INSTALLED_")}
                  </Select.Option>
                  <Select.Option value={2}>
                    {this.context.translate("_UNINSTALLED_")}
                  </Select.Option>
                  <Select.Option value={3}>
                    {this.context.translate("_EXPIRED_")}
                  </Select.Option>
                  <Select.Option value={4}>
                    {this.context.translate("_EXPIRINGSOON_")}
                  </Select.Option>
                  <Select.Option value={5}>
                    {this.context.translate("_DELETED_")}
                  </Select.Option>
                </Select>
                {/* <Select
                  className="searchInput"
                  style={{ width: 150, borderRadius: "25px" }}
                  onSelect={async (value) => {
                    await this.setState({ deviceFilter: value });
                    await this.searchInputButton();
                    sessionStorage.setItem('deviceFilter_vehiclelist_session', JSON.stringify({
                      deviceFilter: value
                    }));
                  }}
                  value={this.state.deviceFilter}
                  // placeholder="Status"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"
                  )}
                  options={[
                    { label: "Ruptela", value: 1 },
                    { label: "GT06 ", value: 5 },
                    { label: "MDVR", value: 6 },
                    { label: "GV300", value: 7 },
                    { label: "PCBA", value: 8 },
                    { label: "Atelematics", value: 9 },
                    { label: "Teltonika", value: 10 },
                    { label: "Meitrack", value: 11 },
                    { label: "AK11", value: 12 },
                    { label: "Howen MDVR", value: 13 },
                    { label: "BCE", value: 14 },
                    { label: "Wanway", value: 15 },
                    { label: "Rutela Trace5", value: 16 },
                    { label: "FMC 920", value: 17 },
                    { label: "BSJ", value: 18 },
                    { label: "Iridium", value: 22 },
                    { label: "Loura Gateway", value: 23 },
                  ]}
                ></Select> */}

                <Input
                  // placeholder="Search By Brand,Driver Name,Sim No,IMEI,Asset"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_BRAND_DRIVERNAME_SIMNO_IMEI_ASSET_"
                  )}
                  value={this.state.searchField ? this.state.searchField : ""}
                  style={{ width: 350, borderRadius: "25px" }}
                  onChange={(e) => {

                    const value = e.target.value;

                    this.setState({ searchField: value });

                    if (value.length === 0) {
                      this.searchInput("");
                    }
                    // this.searchInput(e);
                  }}
                  onPressEnter={() => {
                    this.searchInput(this.state.searchField);
                  }}
                // value={this.state.searchField}
                // allowClear
                />

                {features.showVehicleListFilters && <>  <Input
                  placeholder={this.context.translate(
                    "_SEARCH_BY_VEHICLE_NO_"
                  )}
                  value={this.state.vehicleNoSearch ? this.state.vehicleNoSearch : null}
                  style={{ width: 160, borderRadius: "25px" }}
                  onChange={(e) => {

                    const value = e.target.value;

                    this.setState({ vehicleNoSearch: value });

                    if (value.length === 0) {
                      this.handleSearch();
                    }
                  }}
                  onPressEnter={(e) => {
                    e.preventDefault();
                    this.handleSearch();
                  }}
                />

                  <DatePicker
                    style={{ width: 125, borderRadius: "25px" }}
                    placeholder={this.context.translate("_INSTALL_FROM_")}
                    onChange={async (val) => {
                      if (val === null) {
                        await this.setState({ installFrom: "" });
                        await this.handleSearch();
                      } else {
                        await this.setState({
                          installFrom: val.format("YYYY-MM-DD"),
                        });
                        await this.handleSearch();
                      }
                    }}
                  />

                  <DatePicker
                    style={{ width: 125, borderRadius: "25px" }}
                    placeholder={this.context.translate("_INSTALL_TO_")}
                    onChange={async (val) => {
                      if (val === null) {
                        await this.setState({ installTo: "" });
                        await this.handleSearch();
                      } else {
                        await this.setState({
                          installTo: val.format("YYYY-MM-DD")
                        });
                        await this.handleSearch();
                      }
                    }}
                  /></>}


                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                /> */}
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={6}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                {(JSON.parse(base64_decode(Cookies.get("data"))).isadmin ==
                  -1 ||
                  JSON.parse(base64_decode(Cookies.get("data"))).isadmin ==
                  3) && (
                    <Dropdown
                      overlayClassName="export-dropdown"
                      menu={this.ExportMenuProps}
                    >
                      <Image
                        style={{
                          height: 18,
                          alignItems: "center",
                          marginInlineEnd: "20px",
                        }}
                        src={kebabIcon}
                      ></Image>
                    </Dropdown>
                  )}
                {(JSON.parse(base64_decode(Cookies.get("data"))).isadmin == 1 && features.showPaymentMenu) &&
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportPaymentMenu}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "20px",
                      }}
                      src={kebabIcon}
                    ></Image>
                  </Dropdown>
                }

                {(this.props.getUserData().isadmin === 1 ||
                  (this.props.getUserData().isadmin === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                    <Button
                      className="uploadExcelButton"
                      onClick={() => this.setState({ showUpload: true })}
                    >
                      <Tooltip
                        title={this.context.translate("_UPLOAD_")}
                        placement="bottom"
                      >
                        <Image
                          style={{
                            height: 18,
                          }}
                          src={uploadIcon}
                        />
                      </Tooltip>
                    </Button>
                  )}
                {((this.props.canDelete("vehiclelist") &&
                  this.props.getUserData().isadmin === -1) ||
                  (this.props.getUserData().isadmin === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                    <Button
                      className="uploadExcelButton"
                      onClick={() => this.setState({ showBulkDelete: true })}
                    >
                      <Tooltip
                        title={this.context.translate("_BULK_DELETE_BY_EXCEL_")}
                        placement="bottom"
                      >
                        <Image
                          style={{
                            height: 18,
                          }}
                          src={deleteVehicleIcon}
                        />
                      </Tooltip>
                    </Button>
                  )}
                <Button
                  className={`downloadExcelButton ${this.state.exportLoading ? "downloadExcelButtonLoading" : ""
                    }`}
                  loading={this.state.exportLoading}
                  disabled={this.vehicleStore?.vehicles?.length > 0 ? false : true}
                  onClick={async () => {

                    let result = [];
                    if (true) {

                      const result = [];
                      this.state.selectedColumns.forEach((obj) => {
                        if (obj.dataIndex === "status2") {
                          result.push("status");
                        } else {
                          result.push(obj.dataIndex);
                        }
                      });

                      var getData = {
                        cid: this.state.companyId == -1 ? 0 : this.state.companyId,
                        UcompanyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
                        isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
                        searchField: this.state.searchField,
                        vehicleIds: this.state.selectedVehicle,
                        status: this.state.status,
                        colList: result,
                        userId: this.props.getUserData().userId,
                        vehicleNo: this.state.vehicleNoSearch,
                        installFrom: this.state.installFrom,
                        installTo: this.state.installTo,
                      };

                      this.setState({ exportLoading: true });

                      try {
                        await this.vehicleStore.exportExcel(getData);
                      } catch (error) {
                        message.error("Failed to export Excel");
                        this.setState({ exportLoading: false });
                      } finally {
                        this.setState({ exportLoading: false });
                      }

                    }
                  }}
                >
                  <Tooltip title="Download Excel" placement="bottom">
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>

                {(Number(this.props.getUserData().isadmin) === -1 ||
                  Number(this.props.getUserData().isadmin) === 3) &&
                  this.props.canCreate("vehiclelist") && (
                    <Button
                      className="addButtonClass"
                      onClick={() =>
                        this.setState({
                          openVehicleAddForm: true,
                          vehicleIdForEdit: "",
                        })
                      }
                    >
                      <Image
                        style={{ marginInlineEnd: "5px", width: 13 }}
                        src={require("../assets/images/NewDesign/plus (Stroke).png")}
                      ></Image>
                      {this.context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_ADDBTN_"
                      )}
                    </Button>
                  )}
              </Space>
            </Col>
          </Row>

          <ListTable
            rowSelection={{
              // columnWidth: 2,
              // fixed: true,
              preserveSelectedRowKeys: true,
              selectedRowKeys: this.state.selectedVehicle,
              onChange: async (selectedRowKeys, selectedRows) => {
                // await this.setState({})
                await this.setState({ selectedVehicle: selectedRowKeys });

                // const selectedFullImei = selectedRows.map((row) => row.full_imei);
                // console.log(selectedFullImei)
                await this.setState({ full_imei: selectedRows });
              },
            }}
            // value={this.state.selectedRowKeys}
            rowKey="vehicleId"
            currentPage={this.state.currentPage}
            total={this.vehicleStore?.total}
            pageSize={this.state.pageSize}
            columns={this.state.column}
            dataSource={this.vehicleStore?.vehicles}
            loading={this.vehicleStore?.loading}
            onChange={this.handleTableChange}
          // scroll={{
          //   x:1800
          // }}
          />
          {/* {console.log(this.props.getUserData().isadmin, "this.props.getUserData().isadmin === -1")} */}
          {this.props.getUserData().isadmin !== 1 && <Modal
            // title={this.context.translate("_RENEW_VEHICLE_")}
            title={
              <div className="deleteModalTitle">
                <span> {this.context.translate("_RENEW_VEHICLE_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ renewVehicle: false })}
                />
              </div>
            }
            open={
              this.state.selectedVehicle.length !== 0 && this.state.renewVehicle
            }
            className="addDeptModal"
            description="Renew vehicle"
            onOk={() => this.setState({ renewVehicle: false })}
            onCancel={() => this.setState({ renewVehicle: false })}
            footer={false}
            width={400}
          >
            <Form
              name="renewVehicle"
              layout="vertical"
              onFinish={this.onRenewVehicleSubmit}
              style={{ maxWidth: "100%" }}
            >
              <Form.Item
                name="renewvalue"
                label={this.context.translate("_RENEWAL_FOR_")}
                rules={[{ required: true }]}
              >
                <Select 
                  style={{ width: 350 }}
                  onChange={(value) =>
                    this.onSelectRenew(value)
                  }
                >
                  {features.renewExtraOption && (
                    <>
                      <Select.Option value="14">Set Date</Select.Option>
                      <Select.Option value="11">1 Month</Select.Option>
                      <Select.Option value="12">3 Month</Select.Option>
                      <Select.Option value="13">6 Month</Select.Option>
                    </>
                  )}
                  <Select.Option value="1">1 Year</Select.Option>
                  <Select.Option value="2">2 Year</Select.Option>
                  <Select.Option value="3">3 Year</Select.Option>
                  <Select.Option value="4">4 Year</Select.Option>
                  <Select.Option value="5">5 Year</Select.Option>
                  <Select.Option value="6">6 Year</Select.Option>
                  <Select.Option value="7">7 Year</Select.Option>
                  <Select.Option value="8">8 Year</Select.Option>
                  <Select.Option value="9">9 Year</Select.Option>
                  <Select.Option value="10">10 Year</Select.Option>
                </Select>
              </Form.Item>

              {this.state.showRenewDate && (
                <Form.Item
                  name="renewDate"
                  label={
                    <span>
                      {this.context.translate("_FLEET_REPORTS_DATE_")}
                      <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate("_FLEET_REPORTS_DATE_")} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                  initialValue={dayjs()}
                >
                  <DatePicker
                    style={{ width: "100%", height: "40px" }}
                    format={dateFormat}
                  />
                </Form.Item>
              )}

              {features.renewVehicleInvoiceNo && (
                <Form.Item
                  className="uploadCompany"
                  name="invoiceNo"
                  label={
                    <>
                      {this.context.translate("_INVOICE_NO_")}
                      <span style={{ color: "red" }}> *</span>
                    </>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter Invoice No",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              )}

              <div className="addDeptModalButtons">
                <Button
                  className="addDeptModalCancelButton"
                  onClick={() => this.setState({ renewVehicle: false })}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  className="addDeptModalOkButton"
                  htmlType="submit"
                // loading={this.state.loading}
                >
                  {this.context.translate("_SUBMIT_")}
                </Button>
              </div>
            </Form>
          </Modal>
          }


          {this.state.showDeleteModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {" "}
                    {this.context.translate(
                      "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                    )}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ showDeleteModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              description="Are you sure you want to delete this Item? This action cannot be undone."
              centered
              open={
                this.state.selectedVehicle.length !== 0 &&
                this.state.showDeleteModal
              }
              footer={null}
              width={400}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_SURE_TO_DELETE_")}</p>
              </div>
              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ showDeleteModal: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="deleteModalOkButton"
                  onClick={(e) => {
                    this.deleteMultipleVehicles();

                    this.setState({
                      showDeleteModal: false,
                      selectedVehicle: "",
                    });
                  }}
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )}

          {/* <Modal
            width={350}
            className="alert-model"
            title=<div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-trash3"
              ></i>{" "}
             
              {this.context.translate(
                "_FLEET_VEHICLE_VEHICLELIST_REMOVETITLE_"
              )}
            </div>
            open={
              this.state.selectedVehicle.length !== 0 &&
              this.state.showDeleteModal
            }
            onCancel={() => this.setState({ showDeleteModal: false })}
            footer={[
              <Button
                // key="no"
                onClick={() => this.setState({ showDeleteModal: false })}
              >
                {this.context.translate("_FLEET_RULELIST_CRONRULE_NO_")}
              
              </Button>,
              <Button
                type="primary"
                onClick={(e) => {
                  this.deleteMultipleVehicles();

                  console.log(this.state.selectedVehicle);
                  this.setState({
                    showDeleteModal: false,
                    selectedVehicle: "",
                  });
                }}
              >
                {this.context.translate("_FLEET_RULEDETAIL_ACTIVEDDL_YES_")}
              
              </Button>,
            ]}
          >
            {this.context.translate("_SURE_TO_DELETE_")}
           
          </Modal> */}
        </div>

        {this.state.openAssignForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Assign Vehicle To Company"
          //   title={this.context.translate("_ASSIGN_VEHICLE_TO_COMPANY_")}
          //   centered
          //   visible={this.state.openAssignForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openAssignForm: false });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            // title={this.context.translate("_ADD_NEW_VEHICLE_")}
            open={this.state.openAssignForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ openAssignForm: false })}
            onCancel={() => this.setState({ openAssignForm: false })}
            title={
              <div className="formTitle">
                {this.context.translate("_FLEET_USER_USERLIST_VEHICLE_")}
                <p className="formDescription">
                  {this.context.translate("_ASSIGN_VEHICLE_FORM_DESC_")}
                </p>
              </div>
            }
          >
            <div
              style={{
                height: "100%",
              }}
            >
              <AssignVehicleToCompany
                closeModalAssign={this.closeModalAssign}
              />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Drawer>
        )}

        {this.state.openVehicleAddForm && (
          // <Modal
          //   bodyStyle={{ height: "100%" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Add New Vehicle"
          //   maskClosable={false}
          //   title={this.context.translate("_ADD_NEW_VEHICLE_")}
          //   centered
          //   visible={this.state.openVehicleAddForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openVehicleAddForm: false });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            // title={this.context.translate("_ADD_NEW_VEHICLE_")}
            open={this.state.openVehicleAddForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ openVehicleAddForm: false })}
            onCancel={() => this.setState({ openVehicleAddForm: false })}
          >
            <div
              style={{
                height: "98%",
              }}
            >
              <VehicleAdd2
                vehicleIdForEdit={this.state.vehicleIdForEdit}
                forCopy={this.state.forCopy}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Drawer>
        )}

        <Modal
          open={this.state.modalVisible}
          width={300}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>

        {this.state.showUpload && (
          <>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.showUpload}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="uploadExcelTitle">
                  <Image
                    style={{ height: "60px" }}
                    src={UploadTitleIcon}
                  ></Image>
                  <span> {this.context.translate("_UPLOAD_EXCEL_TITLE_")}</span>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                })
              }
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ margin: "16px 0px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      className="uploadCompany"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[{ required: true }]}
                      required={false}
                    >
                      <CompanyAutocomplete
                        onChange={(companyId) => {
                          this.setState({ excelCompanyId: companyId.value });
                        }}
                      />
                    </Form.Item>
                  )}
                <Dragger
                  onRemove={() =>
                    this.setState({ excelFile: "", fileList: [] })
                  }
                  name="excelFile"
                  customRequest={(options) => this.uploadFunction(options)}
                  // action={
                  //   // config.baseURL + "/index.php?c=company&a=fileupload"
                  //   config.baseURL + this.vehicleStore.uploadExcelUrl
                  // }
                  listType="text"
                  data={{
                    fileType: "accountimport",
                    fieldName: "excelFile",
                  }}
                  onChange={this.getUploadData}
                  beforeUpload={(file) => this.validateFile(file)}
                  maxCount={1}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <Image
                        style={{ width: "90px" }}
                        src={uploadOutlined}
                      ></Image>
                    </div>
                    <div className="uploadFileText">
                      <span>
                        {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                      </span>
                      <p>
                        {this.context.translate("_UPLOAD_TEXT_")}{" "}
                        <span
                          style={{
                            color: "var(--Blue-6, #1890FF)",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                        </span>
                        {this.context.translate("_UPLOAD_TEXT_2_")}
                      </p>
                    </div>
                  </div>
                </Dragger>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  <div className="sampleDownload">
                    <span> {this.context.translate("_SAMPLE_DOWNLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                    <Button onClick={() => this.vehicleStore.sampleExcel()}>
                      <Image src={sampleDownloadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                    </Button>
                  </div>

                  <div className="sampleUpload">
                    <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                    <Button>
                      <Image src={sampleUploadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {this.context.translate("_SAMPLE_UPLOAD_")}
                      </span>{" "}
                    </Button>
                  </div>
                </div>

                <Space className="uploadFooter">
                  <Button
                    className="uploadCancelButton"
                    onClick={() =>
                      this.setState({
                        showUpload: false,
                        excelFile: "",
                      })
                    }
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button
                    htmlType="submit"
                    className="uploadButton"
                  // onClick={() => this.onExcelSubmit()}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </Space>
              </Form>
            </Drawer>{" "}
          </>
        )}

        {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={this.context.translate("_CONFIRM_")}
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            //footer={null}
            onOk={this.confirmStatus}
            onCancel={() => {
              this.setState({ showStatusConfirm: false });
            }}
            width={400}
          >
            {this.state.isActive === true ? (
              <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
            ) : (
              <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
            )}
          </Modal>
        )}

        {this.state.showAlertModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span> {this.context.translate("_FLEET_ALERT_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showAlertModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Please select vehicles."
            centered
            open={this.state.showAlertModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_SELECT_VEHICLES_")}</p>
            </div>
            <div>
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ showAlertModal: false })}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openShareModal && (
          <Modal
            // title="SHARE"
            title={this.context.translate("_FLEET_SERVICE_POILIST_SHARE_")}
            open={this.state.openShareModal}
            onCancel={() => this.setState({ openShareModal: false })}
            footer={null}
            maskClosable={false}
            width={200}
            style={{
              top: 10,
              right: "30px",
            }}
            centered
          >
            <div style={{ display: "inline-grid", gap: "9px" }}>
              <Tag
                icon={<MailOutlined />}
                color="#cd201f"
                onClick={this.shareToEmail}
              >
                Email
              </Tag>

              <Tag
                icon={<WhatsAppOutlined />}
                color="teal"
                onClick={this.shareToWhatsApp}
              >
                WhatsApp
              </Tag>

              <h6 style={{ margin: "0px" }}>
                {this.context.translate("_LINK_TO_SHARE_")}
              </h6>
              <Input
                style={{ height: "36px" }}
                value={`https://www.drive7gps.com/app/index.php?c=vehicle&a=downloadCertificatePdf&vid=${this.state.vehicleId}`}
              // value={`https://www.google.com/maps?q=${this.props.shareSingleLocation}`}
              />
            </div>
          </Modal>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}

        <Modal
          maskClosable={false}
          title={
            <div className="confirmStatusTitle">
              <span>{this.context.translate("_CONFIRM_")}</span>
              <CloseOutlined
                style={{ cursor: "pointer", color: "white" }}
                onClick={() => this.setState({ showUploadInfo: false })}
              />
            </div>
          }
          className="update-statusModal"
          description="Are you sure to change this status?"
          centered
          open={this.state.showUploadInfo}
          footer={null}
          width={500}
          closable={false}
        >
          {this.state.duplicateVehicles.length > 0 && (
            <>
              <p>
                These vehicles already exist and were not imported (
                {this.state.duplicateVehicles.join(", ")})
              </p>
            </>
          )}

          {this.state.duplicateImei.length > 0 && (
            <>
              <p>
                These Imei already exist and were not imported(
                {this.state.duplicateImei.join(", ")})
              </p>
            </>
          )}

          {this.state.importedVehicles.length > 0 && (
            <>
              <p>
                These vehicles were imported sucessfully:(
                {this.state.importedVehicles.join(", ")})
              </p>
            </>
          )}
          {this.state.vehiclesNotExist.length > 0 && (
            <>
              <p>
                Invalid vehicle:(
                {this.state.vehiclesNotExist.join(", ")})
              </p>
            </>
          )}
          {this.state.deletedVehicles.length > 0 && (
            <>
              <p>
                These vehicles were deleted sucessfully:(
                {this.state.deletedVehicles.join(", ")})
              </p>
            </>
          )}

          <div className="confirmStatusButtons">
            <Button
              onClick={() => this.setState({ showUploadInfo: false })}
              className="confirmStatusCancelButton"
            >
              {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
            </Button>

            <Button
              className="confirmStatusOkButton"
              onClick={() => this.setState({ showUploadInfo: false })}
            >
              {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
            </Button>
          </div>
        </Modal>

        {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_CONFIRM_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showStatusConfirm: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              {this.state.isActive === true ? (
                <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
              ) : (
                <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
              )}
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showStatusConfirm: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.confirmStatus()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.apiRegistrationPopup && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_REGISTRATION_API_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ apiRegistrationPopup: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.apiRegistrationPopup}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div style={{ marginBottom: "15px", }}>
              Send Api
              <Radio.Group
                style={{ marginLeft: '10px' }}
                onChange={(e) =>
                  this.handleRadioChange(e)
                }
              >
                <Radio value={2}>Riyadh</Radio>
                <Radio value={1}>Jeddah</Radio>
              </Radio.Group>
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ apiRegistrationPopup: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.handleApiRegistration()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.forceUpdateWASLPopup && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_FORCE_POST_TO_WASL_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ forceUpdateWASLPopup: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.forceUpdateWASLPopup}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div style={{ marginBottom: "15px" }}>
              Are You Sure You Want To Force Post To WASL?
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ forceUpdateWASLPopup: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.handleUpdateWASLDATA()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.showBulkDelete && (
          <>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.showBulkDelete}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="uploadExcelTitle">
                  <Image
                    style={{ height: "60px" }}
                    src={deleteVehicleIcon}
                  ></Image>
                  <span>
                    {" "}
                    {this.context.translate("_DELETE_VEHICLE_TITLE_")}
                  </span>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ showBulkDelete: false })}
              onCancel={() =>
                this.setState({
                  showBulkDelete: false,
                  excelFile: "",
                })
              }
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelDeleteSubmit}
                style={{ margin: "16px 0px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                    <Form.Item
                      name="companyId"
                      className="uploadCompany"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[{ required: true }]}
                      required={false}
                    >
                      <CompanyAutocomplete
                        onChange={(companyId) => {
                          this.setState({ deleteCompanyId: companyId.value });
                        }}
                      />
                    </Form.Item>
                  )}
                <Dragger
                  onRemove={() =>
                    this.setState({ excelFile: "", fileList: [] })
                  }
                  name="excelFile"
                  listType="text"
                  customRequest={(options) => this.uploadFunction(options)}
                  onChange={this.getUploadData}
                  beforeUpload={(file) => this.validateFile(file)}
                  maxCount={1}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <Image
                        style={{ width: "90px" }}
                        src={deleteVehicleIcon}
                      ></Image>
                    </div>
                    <div className="uploadFileText">
                      <span>
                        {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                      </span>
                      <p>
                        {this.context.translate("_UPLOAD_TEXT_")}{" "}
                        <span
                          style={{
                            color: "var(--Blue-6, #1890FF)",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                        </span>
                        {this.context.translate("_UPLOAD_TEXT_2_")}
                      </p>
                    </div>
                  </div>
                </Dragger>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  <div className="sampleDownload">
                    <span> {this.context.translate("_SAMPLE_DOWNLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                    <Button
                      onClick={() => this.vehicleStore.sampleExcelBulkDelete()}
                    >
                      <Image src={sampleDownloadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                    </Button>
                  </div>

                  <div className="sampleUpload">
                    <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                    <Button>
                      <Image src={sampleUploadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {this.context.translate("_SAMPLE_UPLOAD_")}
                      </span>{" "}
                    </Button>
                  </div>
                </div>

                <Space className="uploadFooter">
                  <Button
                    className="uploadCancelButton"
                    onClick={() =>
                      this.setState({
                        showBulkDelete: false,
                        excelFile: "",
                      })
                    }
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button
                    htmlType="submit"
                    className="uploadButton"
                  // onClick={() => this.onExcelSubmit()}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </Space>
              </Form>
            </Drawer>{" "}


          </>
        )}

        {this.state.showStatusLogout && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_CONFIRM_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showStatusLogout: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusLogout}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              <p>{this.context.translate("_LOGOUT_STATUS_")}</p>
            </div>
            <div className="confirmStatusButtons">
              <Button
                className="confirmStatusCancelButton"
                onClick={() => this.setState({ showStatusLogout: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.confirmLogoutStatus()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleList.contextType = StoreContext;
export default observer(withRouter(VehicleList));
